<template>
  <div class="list-page-container">
    <div class="breadcrumbs">维保服务</div>
    <div class="header-button">
      <el-row :gutter="20" class="stats-cards">
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--pending">
            <div class="stat-card__content">
              <div class="stat-card__label">总Banner数</div>
              <div class="stat-card__count">{{ overview.total }}</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--processing">
            <div class="stat-card__content">
              <div class="stat-card__label">首页显示</div>
              <div class="stat-card__count">{{ overview.main }}</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--completed">
            <div class="stat-card__content">
              <div class="stat-card__label">产品类型</div>
              <div class="stat-card__count">2</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="margin-top: 16px;">
        <el-button type="success" icon="el-icon-document-add" @click="addBanner()">新增</el-button>
      </div>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="标题" prop="title">
            <el-input v-model="searchData.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="description">
            <el-input v-model="searchData.description" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="searchData.type" placeholder="请选择">
              <el-option v-for="item in dataDict.BANNER_TYPE" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <div class="list-page-table">
        <custom-table ref="customTableRef" :data="tableData" :columns="columns" :pagination="pagination"
          :height="tableHeight" row-key="seed_id" @sort-change="handleSortChange"
          @selection-change="handleSelectionChange" @current-page-change="handleCurrentChange"
          @size-change="handleSizeChange">
          <!-- 客户栏 -->
          <template #image="{ row }">
            <el-image v-if="row.image_thumb" style="width: 190px; height: 100px" :src="`${imgUrl}${row.image_thumb}`"
              :preview-src-list="[`${imgUrl}${row.image_thumb}`]">
            </el-image>
          </template>
          <!-- 客户栏 -->
          <template #title="{ row }">
            <span class="actions-btn">
              <div class="banner-info">
                <span class="banner-title">{{ row.title }}</span>
                <span class="banner-desc">{{ row.description }}</span>
              </div>
            </span>
          </template>
          <!-- 类型 -->
          <template #type="{ row }">
            <el-tag :type="getTagType(row.type, 1)" effect="plain">
              {{ row.type_name }}
            </el-tag>
          </template>
          <!-- 显示设置 -->
          <template #display_on_main="{ row }">
            首页显示：
            <el-tag :type="getTagType(row.display_on_main, 2)" effect="plain">
              {{ row.display_on_main === 2 ? '是' : '否' }}
            </el-tag>
          </template>
          <!-- 创建时间 -->
          <template #created_at="{ row }">
            {{ formatDateTime(row.created_at) }}
          </template>
          <!-- 操作栏 -->
          <template #actions="{ row }">
            <span class="actions-btn">
              <el-tooltip content="编辑" placement="top" class="table-btn"><i @click="editRow(row)"
                  class="el-icon-edit-outline"></i></el-tooltip>
              <el-tooltip content="删除" placement="top" class="table-btn"><i @click="deleteListRow(row)"
                  class="el-icon-delete"></i></el-tooltip>
            </span>
          </template>
        </custom-table>
      </div>
    </div>
    <el-dialog :title="addBannerTitle" width="500px" :append-to-body="true" :close-on-click-modal="false"
      :visible.sync="addBannerVisible" @closed="closeAddBannerDialog()">
      <el-form ref="addBannerForm" :model="addBannerData" label-position="top">
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="Banner图片（750*400）" prop="image">
              <el-upload class="avatar-uploader" drag :show-file-list="false" :action="uploadUrl"
                :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                <img v-if="addBannerData.image" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Banner标题" prop="title">
              <el-input v-model="addBannerData.title" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Banner内容" prop="title">
              <el-input v-model="addBannerData.description" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Banner类型" prop="type">
              <el-select v-model="addBannerData.type" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in dataDict.BANNER_TYPE" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="显示到首页">
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 8px 0;">
                <div class="help-text">是否在小程序首页轮播中显示</div>
                <el-switch v-model="addBannerData.display_on_main" active-color="#32B768"></el-switch>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="显示标题和内容">
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 8px 0;">
                <div class="help-text">是否在Banner上显示标题和内容文字</div>
                <el-switch v-model="addBannerData.display_text" active-color="#32B768"></el-switch>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="text-right">
              <el-button @click="addBannerVisible = false">取消</el-button>
              <el-button type="success" @click="addBannerSubmit()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import CustomTable from '@/components/custom-table.vue'
import * as DICT from '@/utils/dict/fieldDictionary'

export default {
  name: 'Banner',
  mixins: [listMixin],
  components: {
    CustomTable
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      overview: {},
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      imageUrl: '',
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`,
      addBannerTitle: '新建Banner',
      addBannerVisible: false,
      addBannerData: {
        id: '',
        image: '',
        image_thumb: '',
        title: '',
        description: '',
        type: '',
        type_name: '',
        display_on_main: true,
        display_text: true,
        created_at: ''
      },
      addBannerRules: {
      },
      // 列表相关数据
      searchData: {
        title: '',
        description: '',
        type: null
      },
      columns: [
        { label: '预览', prop: 'image', width: '240' },
        { label: '标题与内容', prop: 'title' },
        { label: '类型', prop: 'type' },
        { label: '显示设置', prop: 'display_on_main', sortable: 'custom' },
        { label: '创建时间', prop: 'created_at', sortable: 'custom' },
        { label: '操作', prop: 'actions', width: '140', align: 'center' }
      ],
      queryListApi: apis.QUERY_BANNER,
      deleteListParams: {
        api: apis.DELETE_BANNER,
        id: 'id'
      }
    }
  },
  mounted() {
    this.queryOverview()
  },
  methods: {
    addBannerSubmit() {
      this.$refs.addBannerForm.validate((valid) => {
        if (!valid) {
          return false
        }

        console.log(this.addBannerData)
        this.addBannerData.display_on_main = this.addBannerData.display_on_main ? 2 : 1
        this.addBannerData.display_text = this.addBannerData.display_text ? 2 : 1
        let request = {}
        if (this.addBannerData.id) {
          request = {
            url: '/api/v1/admin/banners/' + this.addBannerData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              ...this.addBannerData
            }
          }
        } else {
          request = {
            ...apis.SAVE_BANNER,
            params: {
              ...this.addBannerData
            }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.queryListData()
                this.queryOverview()
                this.addBannerVisible = false
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    },
    addBanner() {
      this.addBannerTitle = '新增内容'
      this.addBannerVisible = true
    },
    editRow(row) {
      console.log('编辑行：', row)
      this.addBannerTitle = '编辑Banner'
      this.addBannerVisible = true
      // 映射行数据到对话框表单，并自动选中对应状态按钮
      this.addBannerData = {
        id: row.id,
        image: row.image,
        image_thumb: row.image_thumb,
        title: row.title,
        description: row.description,
        type: row.type,
        type_name: row.type_name,
        display_on_main: row.display_on_main !== 1,
        display_text: row.display_text !== 1,
        created_at: row.created_at
      }
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${row.image}`
    },
    closeAddBannerDialog() {
      this.addBannerData = {
        id: '',
        image: '',
        image_thumb: '',
        title: '',
        description: '',
        type: '',
        type_name: '',
        display_on_main: true,
        display_text: true,
        created_at: ''
      }
      this.$nextTick(() => {
        this.$refs.addBannerForm.clearValidate()
      })
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      // 注意：你的数据是10位秒级时间戳，需要乘以1000转换成毫秒
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      // const hours = String(date.getHours()).padStart(2, '0')
      // const minutes = String(date.getMinutes()).padStart(2, '0')
      // const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getTagType(status, a) {
      if (a === 1) {
        switch (status) {
          case 1: return 'primary'
          case 2: return 'success'
          default: return ''
        }
      } else if (a === 2) {
        console.log('首页')
        switch (status) {
          case 1: return 'info'
          case 2: return 'success'
          default: return ''
        }
      }
    },
    queryOverview() {
      this.overview = []
      const request = {
        ...apis.QUERY_BANNER_OVERVIEW,
        params: {
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.overview = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    handleImageSuccess(res, file) {
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${res.data.id}`
      this.addBannerData.image = res.data.id
    },
    beforeImageUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isImg) {
        this.$message.error('只能上传图片格式!')
      }
      return isImg
    }
  }
}
</script>

<style scoped>
.admin-layout .admin-main .list-page-container .header-button {
  background-color: #f5f5f5;
  margin-bottom: 0px;
}

/* 统计卡片样式 */
.stat-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  background-color: #fff;
}

.stat-card__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card__label {
  font-size: 16px;
  color: oklch(.551 .027 264.364);
  font-weight: 500;
  margin-bottom: 4px;
}

.stat-card__count {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  color: oklch(.21 .034 264.665)
}

.stat-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 20%;
  font-size: 24px;
}

/* 卡片颜色主题（独立样式，便于修改） */

.stat-card--pending .stat-card__icon {
  background-color: #DBEAFE;
  color: #155DFC;
}

.stat-card--processing .stat-card__icon {
  background-color: #DCFCE7;
  color: #00A63E;
}

.stat-card--completed .stat-card__icon {
  background-color: #F3E8FF;
  color: #9810FA;
}

/* 客户信息样式 */
.banner-info {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}

.banner-title {
  font-weight: 400;
  font-size: 16px;
  color: #101828;
}

.banner-desc {
  font-weight: 400;
  font-size: 16px;
  color: #6A7282;
}

/* 操作按钮样式 */
.view-btn {
  color: #4299e1;
  padding: 10px;
}

.view-btn:hover {
  color: #2563eb;
  background-color: transparent;
}

/* 状态按钮组样式 */
.status-btn-group {
  display: flex;
  gap: 10px;
}

.status-btn-group .el-button {
  min-width: 100px;
}

.status-btn-group .el-button.active {
  background-color: #409EFF;
  color: #fff;
  border-color: #409EFF;
}

.Banner-detail {
  width: 100%;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.detail-label {
  display: inline-block;
  width: 80px;
  color: #606266;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
}

.dialog-footer {
  text-align: right;
}

.el-tag--plain.el-tag--info {
  background-color: #fff;
  border-color: #d3d4d6;
  color: #0A0A0A;
}

.el-tag--plain {
  background-color: #2B7FFF;
  border-color: #b3d8ff;
  color: #fff;
}

.el-tag--plain.el-tag--success {
  background-color: #00C950;
  border-color: #c2e7b0;
  color: #fff;
}

/* 视频缩略图上传区域样式 */
::v-deep .avatar-uploader .el-upload-dragger {
  width: 375px !important;
  height: 200px !important;
}

/* 缩略图图标样式 */
.avatar-uploader-icon {
  font-size: 30px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  line-height: 200px;
  text-align: center;
}

/* 缩略图图片样式 */
.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.table-btn {
  width: 38px;
  height: 32px;
  align-content: center;
  border: 0.8px solid #0000001A;
  border-radius: 8px;
}
</style>
